module.exports = __webpack_public_path__ + "static/001.thumb-2b1ffa19479b395c7ed6f9ec07f5dc5b.jpg";